import Products from "@src/mocks/AllProducts.json";
import CartSimilarProducts from "@src/pages/marketplace/components/CartSimilarProducts";
import Product from "@src/pages/marketplace/components/Product";
import ProductsCarousel from "@src/pages/marketplace/components/ProductsCarousel";
import TrendingProducts from "@src/pages/marketplace/components/TrendingProducts";
import { t } from "i18next";
import { NavLink } from "react-router-dom";
import { SwiperSlide } from "swiper/react";

const BillsContainer = () => {
  const bills = [
    {
      id: 1,
      billNumber: "INV-001",
      date: "2024-07-17",
      totalAmount: 100,
      products: [
        { id: 1, title: "Product A", price: 50, image: "https://via.placeholder.com/150" },
        { id: 2, title: "Product B", price: 30, image: "https://via.placeholder.com/150" },
        { id: 3, title: "Product C", price: 20, image: "https://via.placeholder.com/150" },
      ],
    },
    {
      id: 2,
      billNumber: "INV-002",
      date: "2024-07-16",
      totalAmount: 150,
      products: [
        { id: 4, title: "Product D", price: 100, image: "https://via.placeholder.com/150" },
        { id: 5, title: "Product E", price: 50, image: "https://via.placeholder.com/150" },
        { id: 2, title: "Product B", price: 30, image: "https://via.placeholder.com/150" },
      ],
    },
    {
      id: 3,
      billNumber: "INV-003",
      date: "2024-07-15",
      totalAmount: 200,
      products: [
        { id: 6, title: "Product F", price: 150, image: "https://via.placeholder.com/150" },
      ],
    },
  ];

  return (
    <div className="mb-2">
      <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
        {bills.map(bill => (
          <div
            key={bill.id}
            className="relative mb-4 rounded-lg border border-gray-300 bg-white p-6"
          >
            <h2 className="mb-1 text-lg font-bold">
              {t("pages.paymentAndOrder.billnumber")}: {bill.billNumber}
            </h2>
            <p className="mb-1 text-sm text-gray-600">
              {t("components.shared.date")}: {bill.date}
            </p>
            <div className="mt-4 border-t border-gray-200 pt-2">
              {bill.products.map(product => (
                <div key={product.id} className="flex items-center py-2">
                  <img
                    src={product.image}
                    alt={product.title}
                    className="size-16 rounded-md object-cover"
                  />
                  <div className="ml-4">
                    <p className="font-semibold">{product.title}</p>
                    <p className="text-gray-600">€{product.price.toFixed(2)}</p>
                  </div>
                </div>
              ))}
            </div>
            <p className="mt-4 text-gray-600">
              {t("main.shop.price.total")}: €{bill.totalAmount.toFixed(2)}
            </p>
            <div className="absolute bottom-0 right-0 mb-3 mr-3">
              <NavLink
                to={"/marketplace/order_detials/" + bill.id}
                className="rounded-md bg-cyan-700 px-4 py-1 text-sm text-white transition duration-300 hover:bg-cyan-600"
              >
                {t("main.profileTabs.club.details")}
              </NavLink>
            </div>
          </div>
        ))}
      </div>
      <div className="mb-5 mt-3 xl:block">
        {/* carousel start */}
        <div className="mt-3 xl:block">
          <span className="text-xl font-semibold">{t("main.shop.details.similarProducts")}</span>
          <ProductsCarousel spaceBetween={20} slidesPerView={1}>
            {Products.allProducts.map(product => (
              <div key={product.ID}>
                <SwiperSlide>
                  <CartSimilarProducts product={product} />
                </SwiperSlide>
              </div>
            ))}
          </ProductsCarousel>
        </div>
        <div className="mb-5 mt-3 xl:block">
          <span className="text-xl font-semibold">{t("main.contacts.tabs.trending")}</span>
          <ProductsCarousel spaceBetween={20} slidesPerView={1}>
            {Products.allProducts.map(product => (
              <div key={product.ID}>
                <SwiperSlide>
                  <TrendingProducts product={product} />
                </SwiperSlide>
              </div>
            ))}
          </ProductsCarousel>
        </div>
        {/* carousel end */}
        <span className="text-xl font-semibold">{t("main.contacts.tabs.trending")}</span>
        <div className="mb-5 grid grid-cols-2 gap-4 md:grid-cols-5">
          {Products.allProducts.map(product => (
            <div key={product.ID} className="flex justify-center">
              <Product product={product} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BillsContainer;
